import axios from "axios"
import Cookies from "js-cookie";

const api = axios.create({
    // baseURL: "http://localhost:5000/",
    baseURL: "https://bookbrew.onrender.com",
    headers: {
        'Authorization': `Bearer ${Cookies.get('token')}`
    }
})

export default api;